module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAeCAYAAAAy2w7YAAABFElEQVRIie2WsUoDQRCGv4kWtlaCoMTWV0gd7KzSJhDbJQ8gYmWh6QKyYONL2IlvYZFW0BeIXVIkYzPqcbm5PcTq2B8Wjp9/55tjmOOEBpKgp8AEOAOOzX4HnoF7jTJP1kgABLgBLoGOE9sAt8C1RlGv1m6ikUdgnMh0gCvgELioC1VKgg5LkFdgABzYGZj3rbHdqa7nQHaAN+DIrBfgXKMsS7k94Anom/UBnGiUddM36hUgS2BUhgCYN7IMdqdX2bwEdQf4n3Jn1BpQF9gHpgXvwby64+V/VN6jT42ykKDFwa80yqKuWy8v4Xf87ZuR9wm6A2b2vGpQJ5mvBNkibi2opyb59s0ogzIogzJoW/nn5M/6AgWMTzkO2HW2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/goods.png
// module id = bQvv
// module chunks = 1